const PROCTORING_TYPE = {
    NO_PROCTORING: 'no_proctoring',
    PHYSICAL_PROCTORING: 'physical_proctoring',
    REMOTE_PROCTORING: 'remote_proctoring',
}

export default PROCTORING_TYPE
